import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/image.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            Currently I am working as a software engineer at <b className="purple"> UNext Learning</b>  primarily working with the<b className="purple"> MEAN</b>  stack for feature implementation and bug fixes. I am a 2023 undergrad having pursued a B.Tech in CSE from Sikkim Manipal Institute of Technology.
            <br />
            <br />
            I have also worked with <b className="purple"> React</b>  and <b className="purple"> Flutter</b> on personal projects. I am also into writing technical blogs on <b className="purple"> Medium</b>  and contributing to <b className="purple"> open source</b> .
              <br />
              <br />
              I am actively looking for a fte/freelance remote role in the domain of
             <b className="purple"> software development.</b>
              <i>
                <b className="purple">
                  {" "}
                </b>
              </i>
              &nbsp;
              <i>
                <b className="purple"> </b>
              </i>
              <br />
              <br />
              I am always open to discussions. Feel free to reach out to me via linkedin.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/REEKRAJROY"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/ReekrajR"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/royreekraj/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
